import { useState, useCallback, useMemo } from "react";
import { getAssetsFileUrl } from '~/utils/assetsHelper';

export default function useHeader() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const logoUrl = getAssetsFileUrl('logo', 'app-logo.png');

    const handleNavItemClick = useCallback((label) => {
        document.title = `BreakThrough: ${label}`;

        // Use a more React-friendly way to close the menu if possible,
        // but since we are using Bootstrap's data-bs-toggle, 
        // we might still need to interact with the collapse instance.
        const navBar = document.getElementById('navbarSupportedContent');
        if (navBar && navBar.classList.contains('show')) {
            // Bootstrap's way to close via JS if we have bootstrap imported
            if (window.bootstrap) {
                const bsCollapse = window.bootstrap.Collapse.getInstance(navBar);
                if (bsCollapse) {
                    bsCollapse.hide();
                } else {
                    new window.bootstrap.Collapse(navBar).hide();
                }
            } else {
                // Fallback to manual click if bootstrap JS is not available
                const toggler = document.querySelector('.navbar-toggler');
                if (toggler) toggler.click();
            }
        }
    }, []);

    const toggleMenu = useCallback(() => {
        setIsMenuOpen(prev => !prev);
    }, []);

    return {
        logoUrl,
        isMenuOpen,
        toggleMenu,
        handleNavItemClick
    };
}
